import {IRegulationPresetValues} from '../regulation-preset-values.interface';
const overrideJson = require('json-override');

function createCommonPresetValues(): IRegulationPresetValues {
    return {
        sdk: {
            Skin: {
                regulationID: 4,
                brandID: null,
                subBrandID: null,
            },
            Currency: {
                anonymousCurrency: 'USD'
            },
            OAuth2: {
                fakeClientIP: '5.62.92.0'
            }
        },
        orbit: {
            country: 'alb',
            language: 'eng',
            iso2: 'en',
            publicationID: null,
            cmsSource: null
        }
    }
}

export const GIB_COM_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 0,
            subBrandID: 0
        }
    },
    orbit: {
        publicationID: 1841,
        cmsSource: 'https://www.888casino.com'
    }
});

export const GIB_777_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 0,
            subBrandID: 111
        }
    },
    orbit: {
        publicationID: 1910,
        cmsSource: 'https://play-www.777.com',
    }
});

export const GIB_CIP_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 1,
            subBrandID: 53
        }
    },
    orbit: {
        publicationID: 1841,
        cmsSource: 'https://www.888casino.com'
    },
    webData: {
        segments: {
            IsCIP: true
        }
    }
});

export const GIB_CIS_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 8,
            subBrandID: 78
        },
        Currency: {
            anonymousCurrency: 'USD'
        }
    },
    orbit: {
        publicationID: 1841,
        cmsSource: 'https://www.888casino.com'
    },
    webData: {
        segments: {
            IsCIS: true
        }
    }
});
